module.exports = __webpack_public_path__ + "media/audio40.30aeb87f.mp3";